var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.99314 2.00686C4.46598 1.53402 5.14386 1.32877 5.79958 1.45992L9.98954 2.29791C10.3767 2.37534 10.7323 2.56565 11.0115 2.84486L17.3358 9.16912C18.1168 9.95017 18.1168 11.2165 17.3358 11.9975L11.9975 17.3358C11.2165 18.1168 9.95017 18.1168 9.16912 17.3358L2.84486 11.0115C2.56566 10.7323 2.37534 10.3767 2.29791 9.98954L1.45992 5.79958C1.32877 5.14386 1.53402 4.46598 2.00686 3.99314L3.99314 2.00686Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.25 7.5C9.25 8.4665 8.4665 9.25 7.5 9.25C6.5335 9.25 5.75 8.4665 5.75 7.5C5.75 6.5335 6.5335 5.75 7.5 5.75C8.4665 5.75 9.25 6.5335 9.25 7.5Z",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTag);
export default __webpack_public_path__ + "static/media/tag.61a4b24476f626161ee6ea4db3f9f21a.svg";
export { ForwardRef as ReactComponent };